
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ApplicationTitleProps {
  defaultTitle?: string;
}

/**
 * Component that manages the document title
 * It sets the default title and updates when routes change
 */
export const ApplicationTitle: React.FC<ApplicationTitleProps> = ({ 
  defaultTitle = "LamuLamu"
}) => {
  const location = useLocation();
  
  useEffect(() => {
    // Set default title
    document.title = defaultTitle;
    
    // Could add route-specific titles here
    if (location.pathname !== '/') {
      // Remove leading slash and capitalize each word
      const pathSegments = location.pathname.substring(1).split('/');
      const pageTitle = pathSegments
        .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join(' - ');
      
      // Only update if we have a meaningful page title
      if (pageTitle) {
        document.title = `${pageTitle} | ${defaultTitle}`;
      }
    }
    
    return () => {
      // Reset title when unmounting
      document.title = defaultTitle;
    };
  }, [location.pathname, defaultTitle]);
  
  // This component doesn't render anything
  return null;
};

export default ApplicationTitle;
